/**
 * @desc 导出物流补录单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.transportMaster.exportTrackTmsBlReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportTrackTmsBlReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
